// export const logout = ( state ) => {
// }

export const setOutputs = (state, outputs) => {
    state.outputs = outputs
}

export const setOutputsPaginated = (state, outputsPaginatedData) => {
    state.outputsPaginatedData = outputsPaginatedData
}

export const setOutputDetail = (state, output) => {
    state.output = output
}

export const setOutputIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}